import { Component, inject } from "@angular/core";
import { MAT_SNACK_BAR_DATA, MatSnackBarRef } from "@angular/material/snack-bar";
import { MatIcon } from "@angular/material/icon";
import { MatButton } from "@angular/material/button";

export type SnackbarType = "success" | "error";

export interface SnackBarData {
  message: string;
  snackbarType?: SnackbarType;
  action?: string;
}

@Component({
  selector: "onsip-snackbar",
  templateUrl: "./snackbar.component.html",
  styleUrls: ["./snackbar.component.scss"],
  imports: [MatIcon, MatButton]
})
export class SnackbarComponent {
  data = inject<SnackBarData>(MAT_SNACK_BAR_DATA);

  snackBarRef!: MatSnackBarRef<SnackbarComponent>;
  isError: boolean;

  constructor() {
    this.isError = this.data.snackbarType === "error";
  }

  dimiss(): void {
    this.snackBarRef.dismissWithAction();
  }
}
